// extracted by mini-css-extract-plugin
export var container = "paginate-module--container--35o6S";
export var li = "paginate-module--li--3wXl_";
export var linkClass = "paginate-module--linkClass--3orh-";
export var breaker = "paginate-module--breaker--1dE8G";
export var active = "paginate-module--active--39cIx";